import js from './js.svg';
import ts from './ts.svg';
import html from './html.svg';
import css from './css.svg';
import react from './react.svg';
import redux from './redux.svg';
import tailwind from './tailwind.svg';
import jest from './jest.svg';

const frontend = [js, ts, html, css, react, redux, tailwind, jest];

export default frontend;
